import React, { useState } from 'react';
import type { MutableRefObject } from 'react';
import { useSelector } from 'react-redux';

import FormulaDropdown from './FormulaDropdown';
import TableFormulaSheet from './TableFormulaSheet';
import DatePickerContainer from './cellTypes/DatePickerContainer';
import { selectIsMobileAppMode } from '../../platform/platformSelector';

import type { ImMNElement } from '../../../common/elements/elementModelTypes';
import { MNHotInstance } from './tableHotInstanceTypes';
import type { FormulaPickerRef } from './useFormulaPickerController';

type TablePopupsProps = {
    element: ImMNElement;
    gridSize: number;
    isActiveTable: boolean;
    isCurrentlyEditingTableCell: boolean;
    formulaPickerRef: MutableRefObject<FormulaPickerRef | null>;
    locale: string;
    hotTableInstanceRef: MutableRefObject<MNHotInstance | null>;
};

const TablePopups: React.FC<TablePopupsProps> = ({
    element,
    gridSize,
    isActiveTable,
    isCurrentlyEditingTableCell,
    formulaPickerRef,
    locale,
    hotTableInstanceRef,
}) => {
    const isMobileAppMode = useSelector(selectIsMobileAppMode);

    const addFormulaToCell = (formula: string, replacePrevCharacters: number) => {
        if (!formula) return;

        const editor = hotTableInstanceRef.current?.getMNEditor();
        if (!editor) return;

        editor.insertPlainTextAtSelection(`${formula}(`, {
            replacePrevCharacters,
        });
    };

    const refocusCellEditor = () => {
        hotTableInstanceRef.current?.getMNEditor()?.focus();
    };

    const [showFormulaPicker, setShowFormulaPicker] = useState(false);

    return (
        <>
            {isMobileAppMode && isActiveTable && (
                <TableFormulaSheet
                    addFormulaToCell={addFormulaToCell}
                    formulaPickerRef={formulaPickerRef}
                    refocusCellEditor={refocusCellEditor}
                    show={showFormulaPicker}
                    setShow={setShowFormulaPicker}
                />
            )}
            {!isMobileAppMode && (
                <FormulaDropdown
                    ref={formulaPickerRef}
                    addFormulaToCell={addFormulaToCell}
                    show={showFormulaPicker}
                    setShow={setShowFormulaPicker}
                />
            )}
            {isCurrentlyEditingTableCell && (
                <DatePickerContainer
                    showFormulaPicker={showFormulaPicker}
                    isCurrentlyEditingTableCell={isCurrentlyEditingTableCell}
                    gridSize={gridSize}
                    element={element}
                    locale={locale}
                    hotTableInstanceRef={hotTableInstanceRef}
                />
            )}
        </>
    );
};

export default TablePopups;
